import { Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'

export const SocialiseGuide = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 1')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('Click on the button below and a pop-up will appear')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 2')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('On the pop-up, click "Socialise" to initiate interaction with other Moles')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 3')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('This will prompt a transaction on your Crypto wallet. Confirm the transaction to proceed')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 4')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('Wait for the final confirmation. If the above transaction is successful, you will earn EXP')}
      </Text>
    </>
  )
}
